import { Endpoints } from "../network";
import apiClient from "./base";

export const getModules = async () => {
  const response = await apiClient.get(`${Endpoints.getModules}`);

  return response?.data;
};
